










import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import BpcPaymentTable from '@accounting/components/tables/payment-table/payment-table.vue';

@Component({
  name: 'bpc-club-payments',
  components: {
    'bpc-payment-table': BpcPaymentTable,
  },
})
export default class ClubContacts extends Vue {
  /* Lifecycle hooks */
  // created() { }
  // mounted() {}
  // updated () { }
  // destroyed () { }
}
